<div class="container-fluid">
  <!-- Loading State -->
  <div *ngIf="loading" class="text-center py-5">
    <div class="spinner-border text-primary" role="status">
      <span class="visually-hidden">Зареждане...</span>
    </div>
  </div>

  <!-- Message Details -->
  <div *ngIf="!loading && messageDetails" class="message-viewer">
    <div class="card">
      <div class="card-body">
        <!-- Close Button -->
        <div class="d-flex justify-content-end mb-2">
          <button type="button" class="btn btn-sm btn-outline-secondary close-button" (click)="closeModal()">
            <i class="fa fa-times"></i> Затвори
          </button>
        </div>

        <!-- Message Header -->
        <div class="message-header">
          <div class="d-flex align-items-start mb-4">
            <div class="sender-avatar">
              <i class="fa fa-paper-plane fa-3x text-success"></i>
            </div>
            <div class="flex-grow-1 ms-3">
              <div class="d-flex justify-content-between align-items-start">
                <div>
                  <h5 class="mb-1 sender-name">
                    <span class="badge bg-success me-2">Изпратено</span>
                    {{message.senderProfileName || 'Вие'}}
                  </h5>
                  <p class="text-muted mb-0 small">
                    <i class="fa fa-envelope me-1"></i>
                    <span>До: {{message.recipients || 'Неизвестен получател'}}</span>
                  </p>
                </div>
                <div class="text-end">
                  <div class="message-date">
                    <i class="fa fa-calendar me-1"></i>
                    {{formatDate(messageDetails.dateSent)}}
                  </div>
                  <div class="text-muted small" *ngIf="message.senderLoginName">
                    От: {{message.senderLoginName}}
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Subject -->
          <div class="message-subject mb-3">
            <h4 class="mb-0">{{messageDetails.subject}}</h4>
          </div>

          <!-- Message Metadata -->
          <div class="message-metadata mb-3">
            <div class="row g-2">
              <div class="col-auto" *ngIf="messageDetails.messageId">
                <span class="badge bg-light text-dark">
                  <i class="fa fa-hashtag me-1"></i>ID: {{messageDetails.messageId}}
                </span>
              </div>
              <div class="col-auto" *ngIf="messageDetails.rnu || message.rnu">
                <span class="badge bg-light text-dark">
                  <i class="fa fa-barcode me-1"></i>RNU: {{messageDetails.rnu || message.rnu}}
                </span>
              </div>
              <div class="col-auto" *ngIf="messageDetails.templateId || message.templateId">
                <span class="badge bg-light text-dark">
                  <i class="fa fa-file-text me-1"></i>Шаблон: {{messageDetails.templateId || message.templateId}}
                </span>
              </div>
            </div>
          </div>

          <hr class="my-3">
        </div>

        <!-- Message Body -->
        <div class="message-body">
          <div class="message-content p-3 bg-light rounded">
            <div class="message-text" [innerHTML]="messageDetails.message || 'Няма съдържание'"></div>
          </div>
        </div>

        <!-- Additional Fields (Non-Attachment Fields Only) -->
        <div *ngIf="messageDetails.fields && hasFields() && getParsedFields().length > 0" class="message-fields mt-4">
          <div class="d-flex justify-content-between align-items-center mb-3">
            <h6 class="text-muted mb-0">
              <i class="fa fa-info-circle me-2"></i>Допълнителна информация
            </h6>
            <button type="button" class="btn btn-sm btn-outline-secondary" (click)="toggleDrawer()">
              <i class="fa fa-code me-1"></i>Покажи Raw данни
            </button>
          </div>

          <!-- Simple Fields Only -->
          <div *ngFor="let field of getParsedFields()">
            <div class="card bg-light border-0 mb-3">
              <div class="card-body">
                <small class="text-muted d-block">{{field.key}}</small>
                <div class="field-value">{{formatFieldValue(field.value)}}</div>
              </div>
            </div>
          </div>
        </div>

        <!-- Attachments -->
        <div *ngIf="getEnhancedAttachments().length > 0" class="message-attachments mt-4">
          <h6 class="text-muted mb-3">
            <i class="fa fa-paperclip me-2"></i>Прикачени файлове ({{getEnhancedAttachments().length}})
          </h6>
          <div class="attachments-list">
            <div class="row g-3">
              <div class="col-md-6" *ngFor="let attach of getEnhancedAttachments()">
                <div class="card border h-100">
                  <div class="card-body">
                    <!-- File Name -->
                    <div class="d-flex align-items-start mb-3">
                      <i class="fa fa-file-pdf-o fa-2x text-danger me-3"></i>
                      <div class="flex-grow-1">
                        <h6 class="mb-1">{{attach.fileName || 'Неизвестен файл'}}</h6>
                        <small class="text-muted">
                          <i class="fa fa-database me-1"></i>{{formatFileSize(attach.size)}}
                        </small>
                      </div>
                    </div>

                    <!-- File Details (if available from enhanced data) -->
                    <div class="file-details" *ngIf="attach.blobId || attach.hash">
                      <div class="detail-row mb-2" *ngIf="attach.blobId">
                        <small class="text-muted">Blob ID:</small>
                        <span class="ms-2">{{attach.blobId}}</span>
                      </div>
                      <div class="detail-row mb-2" *ngIf="attach.documentRegistrationNumber">
                        <small class="text-muted">Рег. номер:</small>
                        <span class="ms-2">{{attach.documentRegistrationNumber}}</span>
                      </div>
                      <div class="detail-row mb-2" *ngIf="attach.hash">
                        <small class="text-muted">Hash ({{attach.hashAlgorithm}}):</small>
                        <div class="hash-value text-break small mt-1">{{attach.hash}}</div>
                      </div>
                      <div class="detail-row mb-2" *ngIf="attach.isMalicious !== null && attach.isMalicious !== undefined">
                        <small class="text-muted">Статус:</small>
                        <span class="ms-2 badge" [ngClass]="attach.isMalicious ? 'bg-danger' : 'bg-success'">
                          {{attach.isMalicious ? 'Зловреден' : 'Безопасен'}}
                        </span>
                      </div>
                    </div>

                    <!-- Signatures (if available) -->
                    <div *ngIf="attach.signatures && attach.signatures.length > 0" class="mt-3">
                      <h6 class="text-muted mb-2">
                        <i class="fa fa-certificate me-1"></i>Подписи ({{attach.signatures.length}})
                      </h6>
                      <div *ngFor="let signature of attach.signatures" class="signature-item p-2 bg-light rounded mb-2">
                        <div class="mb-1">
                          <small class="text-muted">Издател:</small>
                          <div class="small text-break">{{signature.issuer}}</div>
                        </div>
                        <div class="mb-1">
                          <small class="text-muted">Субект:</small>
                          <div class="small text-break">{{signature.subject}}</div>
                        </div>
                        <div class="row g-2">
                          <div class="col-6">
                            <small class="text-muted">Валиден от:</small>
                            <div class="small">{{formatDateTime(signature.validFrom)}}</div>
                          </div>
                          <div class="col-6">
                            <small class="text-muted">Валиден до:</small>
                            <div class="small">{{formatDateTime(signature.validTo)}}</div>
                          </div>
                        </div>
                        <div class="mt-1" *ngIf="signature.signDate">
                          <small class="text-muted">Дата на подписване:</small>
                          <span class="ms-2 small">{{formatDateTime(signature.signDate)}}</span>
                        </div>
                        <div class="mt-1">
                          <span class="badge" [ngClass]="signature.validAtTimeOfSigning ? 'bg-success' : 'bg-warning'">
                            {{signature.validAtTimeOfSigning ? 'Валиден при подписване' : 'Невалиден при подписване'}}
                          </span>
                        </div>
                      </div>
                    </div>

                    <!-- Download Link -->
                    <div class="mt-3">
                      <button class="btn btn-sm btn-primary w-100" (click)="openFile(attach.downloadLink)">
                        <i class="fa fa-download me-1"></i>Изтегли файл
                      </button>
                      <small class="text-muted d-block mt-1" *ngIf="attach.downloadLinkExpirationDate">
                        Валиден до: {{formatDateTime(attach.downloadLinkExpirationDate)}}
                      </small>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Raw Data Drawer (Offcanvas) -->
  <div class="offcanvas offcanvas-end" [class.show]="drawerOpen" tabindex="-1" [style.visibility]="drawerOpen ? 'visible' : 'hidden'">
    <div class="offcanvas-header">
      <h5 class="offcanvas-title">
        <i class="fa fa-code me-2"></i>Raw JSON данни
      </h5>
      <button type="button" class="btn-close" (click)="toggleDrawer()"></button>
    </div>
    <div class="offcanvas-body">
      <div class="alert alert-info">
        <i class="fa fa-info-circle me-2"></i>
        Това са необработените JSON данни от допълнителната информация.
      </div>
      <pre class="raw-json-display">{{getRawFieldsJson()}}</pre>
    </div>
  </div>

  <!-- Backdrop for drawer -->
  <div class="offcanvas-backdrop fade" [class.show]="drawerOpen" (click)="toggleDrawer()" *ngIf="drawerOpen"></div>
</div>
